import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/play-filled.svg")